import { useQuery } from '@tanstack/react-query';

import { useApi, useAuth } from '../../hooks';
import { UserFeedbackSurvey } from '../../models/survey';

export const useUserFeedbackSurvey = (userId: string, surveyType?: string) => {
  const { api } = useApi();
  const { isAuthenticated, loading, userToken } = useAuth();

  const fetchUserFeedback = async (surveyType: string | undefined) => {
    const scope = !!surveyType ? `?survey_type=${surveyType}` : '';

    const requestObj = {
      route: `/private/feedback/user-survey${scope}`,
      token: userToken,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'Coach-Override': userId,
      },
    };

    return await api(requestObj);
  };

  const { data, isLoading, isError } = useQuery<UserFeedbackSurvey[], Error>({
    queryKey: ['user-feedback', userToken, userId, surveyType],
    queryFn: () => fetchUserFeedback(surveyType),
    enabled: isAuthenticated && !loading && !!userToken,
    refetchOnWindowFocus: false,
  });

  return { userFeedbackSurveyData: data, isLoading, isError };
};
